<template>
  <div class="table-container return-table" v-if="loadingStatus || values.length > 0">
    <loader-block v-if="loadingStatus" :loading="true" />
    <sorted-table
      v-else
      :values="values"
      class="round-container"
    >
      <thead>
        <tr>
          <th colspan="5" class="text-center">Хувьцаа</th>
          <th colspan="3" class="text-center">Ашиг / Алдагдал</th>
        </tr>
        <tr>
          <th scope="col" class="text-right">
            <sort-link name="symbol">Симбол</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="qty">Тоо ширхэг</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="avg_price">Дундаж үнэ /авсан/</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="total">Нийт хөрөнгө оруулалт</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="current_price">Хаалтын ханш</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="diff">Үнэлгээ</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="current">Ашиг / Төгрөг</sort-link>
          </th>
          <th scope="col" class="text-right">
            <sort-link name="percent">Ашиг / Хувиар</sort-link>
          </th>
        </tr>
      </thead>

      <template #body="sort">
        <tbody>
          <tr
            v-for="(item, index) in sort.values"
            :key="index"
            :class="[item.side === 3 ? 'subhead' : '']"
            class="table-row"
            data-toggle="modal"
            data-target="#detailModal"
          >
            <td class="text-right">
              {{ item.symbol | symbol }}
              <span class="exchange-code">/ {{ item.exchange_server_code ?? '--' }}</span>
            </td>
            <td class="text-right">
              {{ item.qty | currency('no-precision', '') }}
            </td>
            <td class="text-right">{{ item.avg_price | currency('', '₮') }}</td>
            <td class="text-right">
              {{ item.total | currency('', '₮') }}
            </td>
            <td class="text-right">
              {{item.current_price | currency('', '₮') }}
            </td>
            <td class="text-right">
              {{ item.current | currency('', '₮') }}
            </td>
            <td
                class="text-right"
                :class="item.diff >= 0 ? 'plus' : 'minus'"
            >
              {{ item.diff | currency('', '₮') }}
            </td>
            <td
              class="text-right"
              :class="item.percent >= 0 ? 'plus' : 'minus'"
            >
              {{ item.percent | currency('', '') }}%
            </td>
          </tr>
        </tbody>
      </template>

      <!-- <tfoot v-if="totalShareBalance"> -->
      <!--   <tr class="table-footer"> -->
      <!--     <td class="text-left">Нийт</td> -->
      <!--     <td class="text-right"></td> -->
      <!--     <td class="text-right"></td> -->
      <!--     <td class="text-right"> -->
      <!--       {{ totalShareBalance.remainingAmount | currency('', '₮') }} -->
      <!--     </td> -->
      <!--     <td></td> -->
      <!--     <td -->
      <!--       class="text-right" -->
      <!--       colspan="2" -->
      <!--       :class=" -->
      <!--         totalShareBalance.currentAmount - -->
      <!--           totalShareBalance.remainingAmount >= -->
      <!--         0 -->
      <!--           ? 'plus' -->
      <!--           : 'minus' -->
      <!--       " -->
      <!--     > -->
      <!--       {{ totalShareBalance.currentAmount | currency('', '₮') }} -->
      <!--     </td> -->
      <!--     <td -->
      <!--       class="text-right" -->
      <!--       :class=" -->
      <!--         totalShareBalance.currentAmount - -->
      <!--           totalShareBalance.remainingAmount >= -->
      <!--         0 -->
      <!--           ? 'plus' -->
      <!--           : 'minus' -->
      <!--       " -->
      <!--     > -->
      <!--       {{ -->
      <!--         (((totalShareBalance.currentAmount - -->
      <!--           totalShareBalance.remainingAmount) / -->
      <!--           totalShareBalance.remainingAmount) * -->
      <!--           100) -->
      <!--           | currency('', '') -->
      <!--       }}% -->
      <!--     </td> -->
      <!--   </tr> -->
      <!-- </tfoot> -->
    </sorted-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      showDetails: false,
      current: null,
      currentSymbol: null,
      values: [],
      currentItem: null,
      loadingStatus: true,
    }
  },
  computed: {
    ...mapGetters([
      // 'remoteBalance',
      // 'shareBalance',
      // 'calculatedShareBalance',
      // 'totalShareBalance',
      // 'tradeHistory',
      // 'remoteBalanceLoading',
      // 'shareBalanceLoading',
      'symbolProfits',
    ]),
  },
  async created() {
    try {
      if (this.symbolProfits === null) await this.fetchData()
      this.populateTable()
    } finally {
      this.loadingStatus = false
    }
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('fetchSymbolProfits')
    },
    populateTable() {
      this.values = this.symbolProfits.map((item) => {

        const current_price = item.current_price;
        const diff = item.diff;
        const current = item.current;

        return {
          symbol: item.symbol,
          exchange_server_code: item.exchange_server_code,
          qty: item.qty,
          avg_price: item.avg_price,
          total: item.total,
          stype: item.stype,
          bond_type: item.bond_type,
          current_price,
          diff,
          current,
          percent: diff / item.total * 100
        }
      })
    },
    appendItem(symbol, item) {
      if (item.side === 3) {
        if (this.currentSymbol !== symbol) this.currentSymbol = symbol
        else this.currentSymbol = null
      }
    },
    perTotal(item) {
      let result = {}
      if (item.remainingQty > 0) {
        result.totalAmount =
          item.closing_price * item.remainingQty - item.remainingAmount
        result.totalPercent =
          ((item.closing_price * item.remainingQty - item.remainingAmount) /
            item.remainingAmount) *
          100
      }
      return result
    },
  },
  watch: {
    values() {
      console.debug('(ReturnTable) calculatedShareBalance: ', this.calculatedShareBalance)
      console.debug('(ReturnTable) values: ', this.values)
    }
  },
}
</script>
<style lang="scss" src="./ReturnTable.scss"></style>
